import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <p className="mb-8 flex items-center gap-4 text-[11px] font-medium uppercase tracking-[0.35em] text-champagne">
    <span className="h-px w-10 bg-champagne/70" />
    {children}
  </p>
);
